module.exports = __webpack_public_path__ + "img/tooltip_default.0fc8c541.png";